import { Outlet, useOutletContext } from 'react-router-dom'

import { Currency } from 'dinero.js'
import {
  ItManagementApplicationsPageQueryDocument,
  ItManagementBankingBankAccountFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { useBankingProvidersConfigurations } from 'modules/expenses/hooks/useBankingProvidersConfigurations'

const ApplicationsPage = () => {
  const { currency } = useOutletContext<{ currency: Currency }>()

  const {
    data,
    loading: loadingData,
    error: dataError,
  } = useQuery(ItManagementApplicationsPageQueryDocument)
  const bankAccount = data?.banking?.accountsConnection.nodes[0]?.bankAccountsConnection.nodes[0]
  const onboarding = data?.banking?.onboardingsConnection.nodes[0]
  const onboardingInProgress = onboarding?.status != 'completed'

  const {
    loading: loadingAccountsProviders,
    accountProvidersAvailable,
    error: configError,
  } = useBankingProvidersConfigurations()

  return (
    <Outlet
      context={{
        error: dataError || configError,
        loading: loadingData || loadingAccountsProviders,
        accountProvidersAvailable,
        currency,
        bankAccount,
        onboardingInProgress,
      }}
    />
  )
}
export const useApplicationsContext = () => {
  return useOutletContext<{
    error: boolean
    loading: boolean
    accountProvidersAvailable: boolean
    onboardingInProgress: boolean
    currency: Currency
    bankAccount?: ItManagementBankingBankAccountFragment
  }>()
}

export default ApplicationsPage
